import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { Link } from 'react-router-dom';
import Loader from "../Chargers/Loader" // Import the Loader component
import request from '../../Apis/request';
import ReactPaginate from 'react-paginate'; // Import ReactPaginate
import "../Chargers/Charger.css";

const UserRequest = () => {
  document.title = "User Request Transactions";

  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [UserRequestData, setUserRequestData] = useState([]);
  const [filteredChargerData, setFilteredChargerData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [userStatuses, setUserStatuses] = useState({});
  const [statusListing, setStatusListing] = useState([]);
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); // State for total pages

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    // Filter ChargerData based on charger_name
    const filteredData = UserRequestData.filter(charger => 
      charger?.name?.toLowerCase().includes(value)
    );
    setFilteredChargerData(filteredData);
  };

  const fetchChargers = async (currentPage) => {
    setLoading(true);
    
    const apiEndpoint = `${BaseURL}/user/allCharging-transaction/?page=${currentPage}`;
    
    try {
        const response = await axios.get(apiEndpoint, {
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${uniqueToken}`,
            },
        });
        console.log("response", response);
        setUserRequestData(response.data.data.data || []);
        setFilteredChargerData(response.data.data.data || []); // Initially set filteredChargerData to the full data set
        setPageCount( Math.floor(response.data.data.totalCount/23) || 0); // Set the total page count from the API response
    } catch (error) {
        console.error("Error fetching ChargerData:", error);
    } finally {
        setLoading(false);
    }
  };

  useEffect(() => {
    fetchChargers(page); // Fetch data for the current page
  }, [page]);

  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };

  const DeleteFunction = async (id) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then(async (results) => {
      const DeletechargerApi = `${BaseURL}/chargers/delete`;
  
      if (results.value) {
        try {
          const res = await axios.put(`${DeletechargerApi}/${id}`, {}, {
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              Authorization: `Bearer ${uniqueToken}`,
            },
          });
  
          if (res.data.statusCode === 200) {
            Swal.fire({
              icon: "success",
              title: "Deleted!",
              text: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            fetchChargers(page); // Refresh the data after deletion
          } else {
            Swal.fire({
              icon: "info",
              title: "Notice",
              text: res.data.message || "Unexpected result. Please try again.",
            });
            fetchChargers(page); // Refresh the data even if there's an issue
          }
  
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "An error occurred while deleting the user.",
          });
        }
      }
    });
  };

  const handleStatusType = async (event, userId) => {
    const status = event.target.value;
  
    // Update local state
    setUserStatuses(prevStatuses => ({
      ...prevStatuses,
      [userId]: status
    }));
  
    const url = `${BaseURL}/chargers/changestatus/${userId}`;
  
    // Create JSON payload
    const statusData = { status };
  
    try {
      // Send status as JSON instead of FormData
      const response = await axios.put(url, statusData, {
        headers: {
          "Content-Type": "application/json", // Send as JSON
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
  
      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.message, 
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        console.log("Failed to update status", response.data);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
  

  const fetchStatusListing = async () => {
    const apiEndpoint = `${BaseURL}/settings/charger/status`;

    setLoading(true);

    var url = apiEndpoint

    let res = await request({
      url: url,
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${uniqueToken}`,
      },
    });

    console.log("res", res);
   
    if (res && res.data) {
      setStatusListing(res.data);
      }

    return [];
  };

  useEffect(() => {
    fetchStatusListing();
  }, []);
  

  console.log("UserRequestData", UserRequestData);
  console.log("statusListing", statusListing);
  console.log("pagecount", pageCount);
 

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
              <div className="d-flex justify-content-between align-items-center">
                <h4>  User Request Transactions</h4>
             
              </div>
              <hr style={{ marginTop: "5px" }} />

              <div className="row">
                <div className="col-sm-12">
                  <form className="form-horizontal" role="form" method="post" style={{ marginTop: "5px" }}>
                    <div className="row px-3">
                      <div className="col-md-2">
                        <div className="form-group">
                          <label style={{ marginLeft: "10px" }} className="control-label">Search</label>
                          <input
                            type="text"
                            placeholder="Search User Name..."
                            onChange={handleSearchChange}
                            value={searchTerm}
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div className="card-body" style={{ marginLeft: "-19px" }}>
                {loading ? (
                  <Loader /> // Use the Loader component
                ) : (
                  <>
                    <div className="table-responsive">
                      <table className="display dataTable" id="advance-1">
                        <thead>
                          <tr>
                            <th>Sr. No</th>
                            
                            <th>User Name</th>
                            <th>Mobile</th>
                            <th>Email</th>
                            <th>Charger Name</th>
                            <th>Amount</th>
                            <th>Connector ID</th>
                            <th>Status</th>
                            <th>Created Date</th>
                            <th>Updated Date</th>
                        
                          </tr>
                        </thead>
                        <tbody>
                          {filteredChargerData?.length === 0 ? (
                            <tr>
                              <td colSpan="8" className="text-center">No Data Available</td>
                            </tr>
                          ) : (
                            filteredChargerData?.map((u, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                               
                                <td>{u?.name}</td>
                                <td>{u?.mobile}</td>
                                <td>{u?.email}</td>
                                <td>{u?.charger_name}</td>
                                <td> {u?.requiredAmountCharging?.amount}</td>
                                <td> {u?.requiredAmountCharging?.connector_id}</td>
                                <td>
  {u?.requiredAmountCharging?.status ? (
    <button
      style={{ width: "100px" }} // Fixed width for the button
      className={`btn ${
        u.requiredAmountCharging.status === "Unused"
          ? "btn-success"
          : u.requiredAmountCharging.status === "Used"
          ? "btn-warning"
          : ""
      }`}
    >
      {u.requiredAmountCharging.status}
    </button>
  ) : null}
</td>


                                <td>{u?.createdAt}</td>
                                <td>{u?.updatedAt}</td>
                    
                                
                         


                              
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="pagination-container mt-4">
                      <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        forcePage={page - 1} 
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserRequest;
